<script setup lang="ts">
// types
import type { BlockCardIconProps } from '@ts-blocks/block-card-icon/interfaces'
import type { CardIconDesktopScaleFrom } from '@UI/Cards/CardIcon'
// components
import { CardIcon } from '@UI/Cards/CardIcon'
import { AppIconStrapi } from '@UI/Icons/AppIconStrapi'

defineOptions({
  name: 'BlockCardIcon',
})

withDefaults(defineProps<{
  block: BlockCardIconProps
  desktopScaleFrom?: CardIconDesktopScaleFrom
}>(), {
  desktopScaleFrom: 'tablet',
})
</script>

<template>
  <CardIcon
    class="block-card-icon"
    layout="vertical"
    :surface="block.color"
    :shape="block.shape ?? undefined"
    :color="block.shapeColor ?? undefined"
    :desktop-scale-from="desktopScaleFrom"
    :title="block.title"
    :description="block.description"
  >
    <template #icon>
      <AppIconStrapi
        v-if="block.icon"
        :icon="block.icon"
      />
    </template>
  </CardIcon>
</template>

<style scoped lang="scss" src="@scss/components/Blocks/BlockCardIcon.scss" />
